"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUTOMA_CARD_MANIFEST = void 0;
const CardName_1 = require("../../CardName");
const GameModule_1 = require("../../GameModule");
const CardManifest_1 = require("../CardManifest");
const AphroditeBot_1 = require("./AphroditeBot");
const CredicorBot_1 = require("./CredicorBot");
const EcolineBot_1 = require("./EcolineBot");
const HelionBot_1 = require("./HelionBot");
const InterplanetaryCinematicsBot_1 = require("./InterplanetaryCinematicsBot");
const MonsInsuranceBot_1 = require("./MonsInsuranceBot");
const NirgalBot_1 = require("./NirgalBot");
const PhobologBot_1 = require("./PhobologBot");
const PolyphemosBot_1 = require("./PolyphemosBot");
const TharsisBot_1 = require("./TharsisBot");
const ThorgateBot_1 = require("./ThorgateBot");
const UNMIBot_1 = require("./UNMIBot");
const VitorBot_1 = require("./VitorBot");
exports.AUTOMA_CARD_MANIFEST = new CardManifest_1.CardManifest({
    module: GameModule_1.GameModule.Automa,
    corporationCards: [
        { cardName: CardName_1.CardName.THARSIS_BOT, Factory: TharsisBot_1.TharsisBot },
        { cardName: CardName_1.CardName.CREDICOR_BOT, Factory: CredicorBot_1.CredicorBot },
        { cardName: CardName_1.CardName.HELION_BOT, Factory: HelionBot_1.HelionBot },
        { cardName: CardName_1.CardName.UNMI_BOT, Factory: UNMIBot_1.UNMIBot },
        { cardName: CardName_1.CardName.ECOLINE_BOT, Factory: EcolineBot_1.EcolineBot },
        { cardName: CardName_1.CardName.MONS_INSURANCE_BOT, Factory: MonsInsuranceBot_1.MonsInsuranceBot },
        { cardName: CardName_1.CardName.VITOR_BOT, Factory: VitorBot_1.VitorBot },
        { cardName: CardName_1.CardName.THORGATE_BOT, Factory: ThorgateBot_1.ThorgateBot },
        { cardName: CardName_1.CardName.APHRODITE_BOT, Factory: AphroditeBot_1.AphroditeBot, compatibility: GameModule_1.GameModule.Venus },
        { cardName: CardName_1.CardName.POLYPHEMOS_BOT, Factory: PolyphemosBot_1.PolyphemosBot },
        { cardName: CardName_1.CardName.INTERPLANETARY_CINEMATICS_BOT, Factory: InterplanetaryCinematicsBot_1.InterplanetaryCinematicsBot },
        { cardName: CardName_1.CardName.PHOBOLOG_BOT, Factory: PhobologBot_1.PhobologBot },
        { cardName: CardName_1.CardName.NIRGAL_BOT, Factory: NirgalBot_1.NirgalBot },
    ],
});
//# sourceMappingURL=AutomaCardManifest.js.map